import Vue from 'vue'
import { QUOTE_MAID_PARAM, QUOTE_MAID_PARAM_GENERAL, QUOTE_MAID_GENERAL, QUOTE_MAID_PLANS, QUOTE_MAID_PARAM_PLAN_LOADING, QUOTE_MAID_PARAM_PLAN_SUCCESS, QUOTE_MAID_PARAM_PLAN_FAIL, QUOTE_MAID_RISK, QUOTE_MAID_PAYMENT, QUOTE_MAID_ADJ_CANCEL, QUOTE_MAID_RECALCULATE_LOADING, QUOTE_MAID_RECALCULATE_SUCCESS, QUOTE_MAID_RECALCULATE_FAIL } from '@/store/types'
import { commitPkgPremium } from './quote'
import { removeFormatNumber } from '@/utils/number'
import { formatServerTimeFormat } from '@/utils/date'
export const maid = {
  [QUOTE_MAID_PARAM](state, data) {
    // Note: Key - ignoreValue is reserved
    if (data) {
      const formatData = data
      let ignoreValue = data.ignoreValue
      if (ignoreValue === undefined) {
        ignoreValue = false
      }
      Object.keys(formatData).forEach(function (key) {
        if (key !== 'ignoreValue') {
          const arr = formatData[key]
          if (arr) {
            if (Array.isArray(arr)) {
              // Make it so that its value - label (easier to search)
              arr.map(obj => {
                if (!ignoreValue) {
                  obj.label = obj.value + ' - ' + obj.label
                }
              })
            }
            // Initially was using the Object.assign below
            // But due to vue js reactive caveats, we will use Vue.set instead
            Vue.set(state.quotation.maidParam, key, arr)
          }
        }
      })
    }
  },
  [QUOTE_MAID_PARAM_GENERAL](state) {
    state.quotation.maidParam.generalLoaded = true
  },
  [QUOTE_MAID_GENERAL](state, data) {
    if (data) {
      state.quotation.commonForm.product = data.product
      state.quotation.commonForm.scheme = data.scheme
      state.quotation.commonForm.duration = data.duration
      state.quotation.commonForm.acceptDate = data.acceptDate
      state.quotation.commonForm.startDate = data.startDate
      state.quotation.commonForm.endDate = data.endDate
      state.quotation.commonForm.campaign = data.campaign
      state.quotation.commonForm.promotion = data.promotion
      Vue.set(state.quotation.commonForm, 'optCvr', data.optCvr)

      // Reset plans init (always get new plans after 1st screen)
      state.quotation.maidParam.plans.init = 0
    }
  },
  [QUOTE_MAID_PARAM_PLAN_LOADING](state) {
    state.quotation.maidParam.plans.init = 0
    state.quotation.maidParam.plans.initErr = []
    state.quotation.maidParam.plans.limitsText = []
    state.quotation.maidParam.plans.plans = []
  },
  [QUOTE_MAID_PARAM_PLAN_SUCCESS](state, data) {
    state.quotation.maidParam.plans.limitsText = data.limitsText
    state.quotation.maidParam.plans.plans = data.plans
    state.quotation.maidParam.plans.init = 1
    state.quotation.maidParam.plans.initErr = []
  },
  [QUOTE_MAID_PARAM_PLAN_FAIL](state, data) {
    state.quotation.maidParam.plans.init = 2
    state.quotation.maidParam.plans.limitsText = []
    state.quotation.maidParam.plans.plans = []
    state.quotation.maidParam.plans.initErr = []
    if (data && data.length > 0) {
      state.quotation.maidParam.plans.initErr = data
    }
  },
  [QUOTE_MAID_PLANS](state, data) {
    state.quotation.maidForm.planNo = data

    // Save premium info to commonInfo
    const plan = state.quotation.maidParam.plans.plans.find(x => x.planNo === data)
    if (plan && plan.premium) {
      commitPkgPremium(state, plan.premium)

      // Flag reviewPlan init as 1 (as it wont trigger recalculate when coming back from the next page)
      state.quotation.maidParam.reviewPlan.init = 1
    } else {
      commitPkgPremium(state, null)
    }
  },
  [QUOTE_MAID_RISK](state, data) {
    if (data) {
      // Applicant Information
      const { applicant } = state.quotation.commonForm

      applicant.appSalutation = data.applicant.appSalutation
      applicant.appName = data.applicant.appName
      applicant.appNationality = data.applicant.appNationality
      applicant.appNricPassport = data.applicant.appNricPassport
      if (data.applicant.appDob) {
        applicant.appDob = formatServerTimeFormat(data.applicant.appDob)
      }
      applicant.appGender = data.applicant.appGender
      applicant.appOccupation = data.applicant.appOccupation
      applicant.appEmployerName = data.applicant.appEmployerName
      applicant.appJointScheme = data.applicant.appJointScheme
      applicant.appEmail = data.applicant.appEmail
      applicant.appMobileNo = data.applicant.appMobileNo
      applicant.appTelNo1 = data.applicant.appTelNo1
      applicant.appTelNo2 = data.applicant.appTelNo2
      applicant.appPostalCode = data.applicant.appPostalCode
      applicant.appAdd1 = data.applicant.appAdd1
      applicant.appAdd2 = data.applicant.appAdd2
      applicant.appAdd3 = data.applicant.appAdd3
      applicant.appAdd4 = data.applicant.appAdd4
      applicant.mailAdd = data.applicant.mailAdd
      applicant.mailPostalCode = data.applicant.mailPostalCode
      applicant.mailAdd1 = data.applicant.mailAdd1
      applicant.mailAdd2 = data.applicant.mailAdd2
      applicant.mailAdd3 = data.applicant.mailAdd3
      applicant.mailAdd4 = data.applicant.mailAdd4

      // Maid Risk
      const { maidForm } = state.quotation

      maidForm.gtSalutation = data.guarantor.gtSalutation
      maidForm.gtName = data.guarantor.gtName
      maidForm.gtNationality = data.guarantor.gtNationality
      maidForm.gtNric = data.guarantor.gtNric
      if (data.guarantor.gtDob) {
        maidForm.gtDob = formatServerTimeFormat(data.guarantor.gtDob)
      }
      maidForm.gtGender = data.guarantor.gtGender
      maidForm.gtOccupation = data.guarantor.gtOccupation
      maidForm.gtEmployerName = data.guarantor.gtEmployerName
      if (data.guarantor.gtEstAnnualIncome) {
        maidForm.gtEstAnnualIncome = removeFormatNumber(data.guarantor.gtEstAnnualIncome)
      }
      maidForm.gtEmail = data.guarantor.gtEmail
      maidForm.gtMobileNo = data.guarantor.gtMobileNo
      maidForm.gtTelNo1 = data.guarantor.gtTelNo1
      maidForm.gtTelNo2 = data.guarantor.gtTelNo2
      maidForm.gtAdd = data.guarantor.gtAdd
      maidForm.gtPostalCode = data.guarantor.gtPostalCode
      maidForm.gtAdd1 = data.guarantor.gtAdd1
      maidForm.gtAdd2 = data.guarantor.gtAdd2
      maidForm.gtAdd3 = data.guarantor.gtAdd3
      maidForm.gtAdd4 = data.guarantor.gtAdd4

      maidForm.fwTransNo = data.fw.fwTransNo
      maidForm.fwName = data.fw.fwName
      maidForm.fwNationality = data.fw.fwNationality
      maidForm.fwPassport = data.fw.fwPassport
      if (data.fw.fwDob) {
        maidForm.fwDob = formatServerTimeFormat(data.fw.fwDob)
      }
      maidForm.fwGender = data.fw.fwGender
      maidForm.fwWPNo = data.fw.fwWPNo
      maidForm.fwWPType = data.fw.fwWPType
    }
  },
  [QUOTE_MAID_PAYMENT](state, data) {
    state.quotation.commonForm.paytMode = data.paytMode
    state.quotation.commonForm.paytCCNo = data.paytCCNo
    state.quotation.commonForm.paytCCName = data.paytCCName
    state.quotation.commonForm.paytCCType = data.paytCCType
    state.quotation.commonForm.paytCCExpMth = data.paytCCExpMth
    state.quotation.commonForm.paytCCExpYr = data.paytCCExpYr
    state.quotation.commonForm.paytCCCvv = data.paytCCCvv
  },
  [QUOTE_MAID_ADJ_CANCEL](state) {
    // Reset Plan
    state.quotation.maidForm.planNo = null

    // Reset Adjustment
    state.quotation.commonForm.adjDiscount = null

    // Reset Premium
    commitPkgPremium(state, null)
  },
  [QUOTE_MAID_RECALCULATE_LOADING](state) {
    state.quotation.maidParam.reviewPlan.init = 0
    state.quotation.maidParam.reviewPlan.initErr = []
  },
  [QUOTE_MAID_RECALCULATE_SUCCESS](state, data) {
    state.quotation.maidParam.reviewPlan.init = 1
    state.quotation.maidParam.reviewPlan.initErr = []
    commitPkgPremium(state, data)
  },
  [QUOTE_MAID_RECALCULATE_FAIL](state, data) {
    state.quotation.maidParam.reviewPlan.init = 2
    if (data && data.length > 0) {
      state.quotation.maidParam.reviewPlan.initErr = data
    }
    // Reset Premium
    commitPkgPremium(state, null)
  }
}
